// removed by extract-text-webpack-plugin
module.exports = {"field":"field___1Bl0r","label":"label___3Qj0f","value":"value___38Bfs","iconContainer":"iconContainer___1gJZb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReadOnlyField/index.scss
// module id = 102
// module chunks = 0